module.exports = __webpack_public_path__ + "caret.svg?2979f1dddf298c1ee238096162380a52";